
  import { Vue, Component } from "vue-property-decorator";
  import Skeleton from "@/components/skeletonPlaceholder/Skeleton.vue";

  @Component({
    components: {
      Skeleton,
    },
  })
  export default class ManagementRemoveDocumentPlaceholder extends Vue {
  }
